// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"249":"bff57a93","258":"75412ff1","369":"81a941cb","766":"33e28624","925":"a0b64182","939":"5afd1428","961":"d0cad226"}[chunkId] + ".chunk.js";
};